import React from 'react';
import { Grid, Card, Text, Stack, Group, Progress, Badge } from '@mantine/core';
import { TeamAnalytics } from 'types/analytics';

interface TeamComparisonProps {
    data: TeamAnalytics;
}

export const TeamComparison: React.FC<TeamComparisonProps> = ({ data }) => {
    const totalRounds = data.CT.roundsWon + data.T.roundsWon;
    const ctWinPercentage = totalRounds > 0 ? (data.CT.roundsWon / totalRounds) * 100 : 0;
    const tWinPercentage = totalRounds > 0 ? (data.T.roundsWon / totalRounds) * 100 : 0;

    return (
        <Grid gutter="md">
            <Grid.Col span={{ base: 12, md: 6 }}>
                <Card shadow="sm" padding="lg" radius="md" withBorder style={{ borderLeft: '4px solid var(--mantine-color-blue-6)' }}>
                    <Stack gap="sm">
                        <Group justify="space-between">
                            <Text fw={600} size="lg">CT ({data.teams[0]?.name || 'Team CT'})</Text>
                            <Badge color="blue" size="lg">{data.CT.roundsWon}</Badge>
                        </Group>

                        <Progress value={ctWinPercentage} color="blue" size="lg" radius="xl" />

                        <Grid gutter="xs" mt="xs">
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Kills</Text>
                                <Text fw={600}>{data.CT.stats.totalKills}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Deaths</Text>
                                <Text fw={600}>{data.CT.stats.totalDeaths}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Avg ADR</Text>
                                <Text fw={600}>{data.CT.stats.avgADR}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">HS%</Text>
                                <Text fw={600}>{data.CT.stats.avgHeadshotPct}%</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">First Kills</Text>
                                <Text fw={600}>{data.CT.stats.totalFirstKills}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Clutches</Text>
                                <Text fw={600}>{data.CT.stats.totalClutchesWon}</Text>
                            </Grid.Col>
                        </Grid>

                        <div style={{ marginTop: '8px' }}>
                            <Text size="xs" c="dimmed" mb={4}>Win Reasons</Text>
                            <Group gap="xs">
                                <Badge size="sm" variant="light">Elim: {data.CT.winReasons.elimination}</Badge>
                                <Badge size="sm" variant="light">Defuse: {data.CT.winReasons.defuse}</Badge>
                                <Badge size="sm" variant="light">Time: {data.CT.winReasons.time}</Badge>
                            </Group>
                        </div>
                    </Stack>
                </Card>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6 }}>
                <Card shadow="sm" padding="lg" radius="md" withBorder style={{ borderLeft: '4px solid var(--mantine-color-orange-6)' }}>
                    <Stack gap="sm">
                        <Group justify="space-between">
                            <Text fw={600} size="lg">T ({data.teams[1]?.name || 'Team T'})</Text>
                            <Badge color="orange" size="lg">{data.T.roundsWon}</Badge>
                        </Group>

                        <Progress value={tWinPercentage} color="orange" size="lg" radius="xl" />

                        <Grid gutter="xs" mt="xs">
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Kills</Text>
                                <Text fw={600}>{data.T.stats.totalKills}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Deaths</Text>
                                <Text fw={600}>{data.T.stats.totalDeaths}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Avg ADR</Text>
                                <Text fw={600}>{data.T.stats.avgADR}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">HS%</Text>
                                <Text fw={600}>{data.T.stats.avgHeadshotPct}%</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">First Kills</Text>
                                <Text fw={600}>{data.T.stats.totalFirstKills}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="xs" c="dimmed">Clutches</Text>
                                <Text fw={600}>{data.T.stats.totalClutchesWon}</Text>
                            </Grid.Col>
                        </Grid>

                        <div style={{ marginTop: '8px' }}>
                            <Text size="xs" c="dimmed" mb={4}>Win Reasons</Text>
                            <Group gap="xs">
                                <Badge size="sm" variant="light">Elim: {data.T.winReasons.elimination}</Badge>
                                <Badge size="sm" variant="light">Bomb: {data.T.winReasons.bomb}</Badge>
                            </Group>
                        </div>
                    </Stack>
                </Card>
            </Grid.Col>
        </Grid>
    );
};






